import {
    API_SUCCESS,
    API_FAIL,
    GET_TOP_SELLING_PRODUCT,
    GET_EARNING_DATA,
    GET_REPORTED_MESSAGES,
    GET_REPORTED_MESSAGES_SUCCESS,
    GET_REPORTED_MESSAGES_FAIL,
    CHANGE_REPORTED_MESSAGE_STATUS,
    CHANGE_REPORTED_MESSAGE_STATUS_SUCCESS,
    CHANGE_REPORTED_MESSAGE_STATUS_FAIL,
} from "./actionType";

export const apiSuccess = (actionType, data) => ({
    type: API_SUCCESS,
    payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
    type: API_FAIL,
    payload: { actionType, error },
});

// charts data
export const getTopSellingProduct = (month) => ({
    type: GET_TOP_SELLING_PRODUCT,
    payload: month
});

/** Earning chart data */
export const getEarningChartsData = (month) => ({
    type: GET_EARNING_DATA,
    payload: month
})

export const getReportedMessages = (params) => ({
    type: GET_REPORTED_MESSAGES,
    payload: params,
})

export const getReportedMessagesSuccess = (messages) => ({
    type: GET_REPORTED_MESSAGES_SUCCESS,
    payload: messages,
})

export const getReportedMessagesFail = (error) => ({
    type: GET_REPORTED_MESSAGES_FAIL,
    payload: error,
})

export const changeReportedMessageStatus = (params) => ({
    type: CHANGE_REPORTED_MESSAGE_STATUS,
    payload: params,
})

export const changeReportedMessageStatusSuccess = (response) => ({
    type: CHANGE_REPORTED_MESSAGE_STATUS_SUCCESS,
    payload: response,
})

export const changeReportedMessageStatusFail = (error) => ({
    type: CHANGE_REPORTED_MESSAGE_STATUS_FAIL,
    payload: error,
})
